<aside
  class="fixed inset-y-0 left-0 z-40 flex flex-col overflow-hidden transition-[width] duration-200 ease-in-out"
  [style.width]="layout.sidebarCollapsed() ? '64px' : '240px'"
  [style.background]="'var(--sidebar-bg)'"
  [style.border-right]="'1px solid var(--sidebar-border)'"
>
  <!-- Brand -->
  <div
    class="flex h-12 shrink-0 items-center px-5"
    [class.justify-between]="!layout.sidebarCollapsed()"
    [class.justify-center]="layout.sidebarCollapsed()"
    [style.border-bottom]="'1px solid var(--sidebar-border)'"
  >
    @if (!layout.sidebarCollapsed()) {
      <a routerLink="/menu" class="flex items-center transition-opacity hover:opacity-80">
        <img src="assets/aleia.webp" alt="Aleia" class="h-10 w-auto object-contain" />
      </a>
      <button
        type="button"
        (click)="layout.collapse()"
        class="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-lg text-gray-900 transition-colors hover:bg-black/5"
        title="Ocultar menú"
      >
        <lucide-icon [img]="icons.PanelLeftClose" [size]="15" />
      </button>
    } @else {
      <!-- Submark ⟶ expand toggle on hover -->
      <button
        type="button"
        (click)="layout.expand()"
        (mouseenter)="hoverLogo.set(true)"
        (mouseleave)="hoverLogo.set(false)"
        class="relative flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-lg text-gray-900 transition-colors hover:bg-black/5"
        title="Mostrar menú"
      >
        <img
          src="assets/brand/submark-color.svg"
          alt="Aleia"
          class="h-9 w-9 object-contain transition-opacity duration-150"
          [class.opacity-0]="hoverLogo()"
        />
        <lucide-icon
          [img]="icons.PanelLeftOpen"
          [size]="17"
          class="absolute inset-0 m-auto transition-opacity duration-150"
          [class.opacity-0]="!hoverLogo()"
        />
      </button>
    }
  </div>

  <!-- Nav -->
  <nav class="flex-1 space-y-1.5 px-3 py-5">
    <a
      routerLink="/menu"
      routerLinkActive="nav-active"
      #rlaHome="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: true }"
      [class]="navItemClass()"
    >
      <lucide-icon
        [img]="icons.LayoutDashboard"
        [size]="18"
        [strokeWidth]="1.9"
        [color]="navIconColor(rlaHome.isActive)"
        class="shrink-0"
      />
      @if (!layout.sidebarCollapsed()) {
        <span class="nav-label text-[13.5px] font-medium">Inicio</span>
      }
    </a>

    @if (canAccessOrientador()) {
      <a
        routerLink="/orientador"
        routerLinkActive="nav-active"
        #rlaOrientador="routerLinkActive"
        [class]="navItemClass()"
      >
        <lucide-icon
          [img]="icons.ScanLine"
          [size]="18"
          [strokeWidth]="1.9"
          [color]="navIconColor(rlaOrientador.isActive)"
          class="shrink-0"
        />
        @if (!layout.sidebarCollapsed()) {
          <span class="nav-label text-[13.5px] font-medium">Orientador</span>
        }
      </a>
    }

    @if (canAccessPorDispensar()) {
      <a
        routerLink="/por-dispensar"
        routerLinkActive="nav-active"
        #rlaPorDispensar="routerLinkActive"
        [class]="navItemClass()"
      >
        <lucide-icon
          [img]="icons.ClipboardList"
          [size]="18"
          [strokeWidth]="1.9"
          [color]="navIconColor(rlaPorDispensar.isActive)"
          class="shrink-0"
        />
        @if (!layout.sidebarCollapsed()) {
          <span class="nav-label text-[13.5px] font-medium">Por dispensar</span>
        }
      </a>
    }

    @if (canAccessDispensaciones()) {
      <a
        routerLink="/dispensaciones"
        routerLinkActive="nav-active"
        #rlaDispensaciones="routerLinkActive"
        [class]="navItemClass()"
      >
        <lucide-icon
          [img]="icons.FileCheck"
          [size]="18"
          [strokeWidth]="1.9"
          [color]="navIconColor(rlaDispensaciones.isActive)"
          class="shrink-0"
        />
        @if (!layout.sidebarCollapsed()) {
          <span class="nav-label text-[13.5px] font-medium">Dispensaciones</span>
        }
      </a>

      <a
        routerLink="/tareas"
        routerLinkActive="nav-active"
        #rlaTareas="routerLinkActive"
        [class]="navItemClass()"
      >
        <lucide-icon
          [img]="icons.ListChecks"
          [size]="18"
          [strokeWidth]="1.9"
          [color]="navIconColor(rlaTareas.isActive)"
          class="shrink-0"
        />
        @if (!layout.sidebarCollapsed()) {
          <span class="nav-label text-[13.5px] font-medium">Tareas</span>
        }
        @if (taskService.count()?.mine; as mine) {
          <span
            class="ml-auto rounded-full px-1.5 py-0.5 text-[10.5px] font-semibold leading-none"
            [style.background]="
              taskService.count()!.overdue ? 'var(--danger-soft)' : 'var(--accent-soft)'
            "
            [style.color]="taskService.count()!.overdue ? 'var(--danger)' : 'var(--accent)'"
            [attr.aria-label]="mine + ' tareas pendientes'"
            >{{ mine }}</span
          >
        }
      </a>
    }

    @if (canAccessAnalisis()) {
      <a
        routerLink="/analisis"
        routerLinkActive="nav-active"
        #rlaAnalisis="routerLinkActive"
        [class]="navItemClass()"
      >
        <lucide-icon
          [img]="icons.Sparkles"
          [size]="18"
          [strokeWidth]="1.9"
          [color]="navIconColor(rlaAnalisis.isActive)"
          class="shrink-0"
        />
        @if (!layout.sidebarCollapsed()) {
          <span class="nav-label text-[13.5px] font-medium">Análisis</span>
        }
      </a>
    }
  </nav>

  <div style="height: 1px; background: var(--sidebar-border); margin: 0 16px"></div>

  <!-- User -->
  <div class="shrink-0 px-3 py-4">
    <div
      class="mb-1 flex items-center gap-3 py-2.5"
      [class.px-3]="!layout.sidebarCollapsed()"
      [class.justify-center]="layout.sidebarCollapsed()"
    >
      <div
        class="flex h-8 w-8 shrink-0 select-none items-center justify-center rounded-full bg-gray-200 text-[12px] font-semibold text-gray-600"
      >
        {{ userInitials() }}
      </div>
      @if (!layout.sidebarCollapsed()) {
        <div class="min-w-0 flex-1">
          <p class="truncate text-[13px] font-semibold text-gray-800">{{ userDisplayName() }}</p>
          <p class="truncate text-[11.5px] text-gray-400">{{ userRoleLabel() }}</p>
        </div>
      }
    </div>
    @if (canAccessSupervisor()) {
      <button
        type="button"
        (click)="supervisorOpen.set(true)"
        class="flex w-full cursor-pointer items-center gap-3 rounded-xl py-2.5 text-[13px] font-medium transition-colors hover:bg-black/5"
        [class.px-3]="!layout.sidebarCollapsed()"
        [class.justify-center]="layout.sidebarCollapsed()"
        style="color: var(--sidebar-text)"
        title="Código de regente"
      >
        <lucide-icon [img]="icons.KeyRound" [size]="16" class="shrink-0 text-gray-400" />
        @if (!layout.sidebarCollapsed()) {
          Código de regente
        }
      </button>
    }
    <button
      type="button"
      (click)="logout()"
      class="flex w-full cursor-pointer items-center gap-3 rounded-xl py-2.5 text-[13px] font-medium transition-colors hover:bg-black/5"
      [class.px-3]="!layout.sidebarCollapsed()"
      [class.justify-center]="layout.sidebarCollapsed()"
      style="color: var(--sidebar-text)"
      title="Cerrar sesión"
    >
      <lucide-icon [img]="icons.LogOut" [size]="16" class="shrink-0 text-gray-400" />
      @if (!layout.sidebarCollapsed()) {
        Cerrar sesión
      }
    </button>
  </div>
</aside>

@if (supervisorOpen()) {
  <app-supervisor-dialog (close)="supervisorOpen.set(false)" />
}
